import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Three stacked chevrons — use when sidebar is closed (tap to open). */
export function TripleChevronOpenIcon({ className }) {
    return (
        <span
            className={cn('inline-flex flex-col items-center justify-center', className)}
            aria-hidden
        >
            <ChevronRight className="h-3 w-3 -mb-0.5 text-primary-700" strokeWidth={2.5} />
            <ChevronRight className="h-3 w-3 -my-0.5 text-primary-700" strokeWidth={2.5} />
            <ChevronRight className="h-3 w-3 -mt-0.5 text-primary-700" strokeWidth={2.5} />
        </span>
    );
}

/** Three stacked chevrons pointing left — use when sidebar is open (tap to hide). */
export function TripleChevronCloseIcon({ className }) {
    return (
        <span
            className={cn('inline-flex flex-col items-center justify-center', className)}
            aria-hidden
        >
            <ChevronLeft className="h-3 w-3 -mb-0.5 text-primary-700" strokeWidth={2.5} />
            <ChevronLeft className="h-3 w-3 -my-0.5 text-primary-700" strokeWidth={2.5} />
            <ChevronLeft className="h-3 w-3 -mt-0.5 text-primary-700" strokeWidth={2.5} />
        </span>
    );
}
